import { Task } from '@atom/types/task';
import { WorkOrderDetailType } from '@atom/types/work';
import { setDisplayDate } from '@atom/utilities/timeUtilities';

import { getRouting, getTaskThreshold } from './hidotOvertimeReportUtilities';

import classes from './hidotOvertimeReport.module.css';

type RoutingGridProps = {
  workOrder: WorkOrderDetailType;
  task: Task;
};

const RoutingGrid = ({ workOrder, task }: RoutingGridProps) => {
  const routing = getRouting(getTaskThreshold(task), workOrder?.createdByName);
  const date = setDisplayDate(workOrder?.completionDate);

  return (
    <div className={classes.sectionContainer}>
      <div className={classes.routingRow}>
        <div className={classes.routingCell}>{`To: ${routing.to}`}</div>
        <div className={classes.routingCell}>{`Date: ${date}`}</div>
      </div>
      <div className={classes.routingRow}>
        <div className={classes.routingCell}>{`From: ${routing.from}`}</div>
        <div
          className={classes.routingCell}
        >{`Through: ${routing.through}`}</div>
      </div>
    </div>
  );
};

export default RoutingGrid;
